import { COMPANY, PENDING } from "@/data/company";

const ACPR =
  "Autorité de contrôle : Autorité de Contrôle Prudentiel et de Résolution (ACPR), 4 Place de Budapest – CS 92459 – 75436 Paris Cedex 09 — https://acpr.banque-france.fr.";

const publisherName = () => COMPANY.legalName || "la société éditrice du site";

const publisherIdentity = () => {
  if (!COMPANY.legalName) {
    return `Le site decennale-artisans.com est édité sous la marque ${COMPANY.brand} par la société éditrice du site. Ses informations d'immatriculation (dénomination sociale, forme juridique, capital, siège, SIREN, RCS, TVA intracommunautaire) sont en cours de publication sur cette page.`;
  }
  const parts = [`Le site decennale-artisans.com est édité sous la marque ${COMPANY.brand} par ${COMPANY.legalName}`];
  if (COMPANY.legalForm) parts.push(COMPANY.legalForm);
  if (COMPANY.address) parts.push(`dont le siège social est situé ${COMPANY.address}`);
  if (COMPANY.siren) parts.push(`SIREN ${COMPANY.siren}`);
  if (COMPANY.rcs) parts.push(COMPANY.rcs);
  let text = `${parts.join(", ")}.`;
  if (COMPANY.vat) text += ` Numéro de TVA intracommunautaire : ${COMPANY.vat}.`;
  const pending = [
    [COMPANY.legalForm, "forme juridique et capital"],
    [COMPANY.address, "siège social"],
    [COMPANY.siren, "SIREN"],
    [COMPANY.rcs, "RCS"],
    [COMPANY.vat, "TVA intracommunautaire"],
  ].filter(([value]) => !value).map(([, label]) => label);
  if (pending.length) text += ` Informations en cours de publication sur cette page : ${pending.join(", ")}.`;
  return text;
};

const contactLine = () => {
  const ways = ["le formulaire de la page « Contact »"];
  if (COMPANY.email) ways.push(`l'adresse ${COMPANY.email}`);
  if (COMPANY.phone) ways.push(`le ${COMPANY.phone}`);
  return `Contact : ${ways.join(", ")}.`;
};

const oriasLine = () =>
  COMPANY.orias
    ? `${publisherName().replace(/^./, (c) => c.toUpperCase())} est immatriculée au registre unique des intermédiaires en assurance, banque et finance (ORIAS) sous le numéro ${COMPANY.orias}${COMPANY.oriasCategory ? `, en qualité de ${COMPANY.oriasCategory}` : ""}. Le registre est consultable sur www.orias.fr.`
    : "Le numéro d'immatriculation au registre unique des intermédiaires en assurance, banque et finance (ORIAS) et la catégorie d'inscription sont en cours de publication sur cette page. Le registre est consultable sur www.orias.fr.";

const mediationLine = () =>
  COMPANY.mediator
    ? `En cas de désaccord persistant après réclamation écrite, vous pouvez saisir gratuitement le médiateur : ${COMPANY.mediator}. Pour un litige lié à un contrat d'assurance, le médiateur compétent est également indiqué dans les documents du contrat.`
    : "En cas de désaccord persistant après réclamation écrite, un médiateur peut être saisi. Les coordonnées du médiateur compétent pour la société éditrice sont en cours de publication ; pour un litige lié à un contrat d'assurance, le médiateur compétent est indiqué dans les documents du contrat (notamment La Médiation de l'Assurance pour les contrats de ses membres : www.mediation-assurance.org).";

const RECLAMATIONS = {
  h: "Réclamations",
  paras: [
    "Toute réclamation relative à nos services peut être adressée gratuitement via le formulaire de contact du site, en précisant l'objet « Réclamation ». Nous accusons réception de votre demande et nous engageons à y répondre dans les meilleurs délais.",
    "Pour toute réclamation relative à un contrat souscrit auprès d'un assureur, adressez-vous en priorité à son service réclamations, dont les coordonnées figurent sur vos documents contractuels.",
  ],
};

export const MENTIONS_LEGALES_DATA = {
  title: "Mentions légales",
  subtitle: `Site decennale-artisans.com — marque ${COMPANY.brand}`,
  sections: [
    {
      h: "Éditeur du site",
      paras: [
        publisherIdentity(),
        `Directeur de la publication : ${COMPANY.publicationDirector || PENDING}.`,
        contactLine(),
      ],
    },
    {
      h: "Intermédiaire en assurance",
      paras: [
        oriasLine(),
        "Encaissement de fonds : le site n'encaisse aucune prime ni aucun fonds ; les contrats sont souscrits directement auprès des partenaires assureurs.",
        ACPR,
      ],
    },
    RECLAMATIONS,
    { h: "Médiation", paras: [mediationLine()] },
    {
      h: "Hébergement",
      paras: [
        `Le site et son service de formulaires sont hébergés par ${COMPANY.host.name}, ${COMPANY.host.address} — ${COMPANY.host.url}.`,
      ],
    },
    {
      h: "Propriété intellectuelle et liens",
      paras: [
        "Les textes, graphismes, logos et l'interface du site sont protégés par le Code de la propriété intellectuelle. Leur reproduction, en tout ou partie, sans autorisation écrite préalable est interdite. Les photographies proviennent de la banque d'images Unsplash.",
        "Les liens hypertextes pointant vers le site sont autorisés, à condition de ne pas présenter nos pages dans un cadre (framing) ni de manière trompeuse.",
      ],
    },
  ],
};

export const REGLEMENTAIRE_DATA = {
  title: "Informations réglementaires",
  subtitle: "Distribution d'assurance — Code des assurances",
  sections: [
    {
      h: "Identité de l'intermédiaire",
      paras: [publisherIdentity(), contactLine()],
    },
    {
      h: "Immatriculation ORIAS",
      paras: [oriasLine(), ACPR],
    },
    {
      h: "Nature du service",
      paras: [
        "Le site propose un service de mise en relation : votre demande de devis est transmise à des professionnels de l'assurance partenaires, spécialistes du bâtiment, qui étudient votre dossier et formulent, le cas échéant, une proposition.",
        "Le site ne fournit pas de recommandation personnalisée automatisée et ne conclut aucun contrat : toute souscription s'effectue entre vous et le partenaire, qui vous fournit alors les conseils et documents précontractuels prévus par le Code des assurances.",
      ],
    },
    {
      h: "Assureurs cités",
      paras: [
        "Les noms figurant dans le comparatif ont une finalité documentaire. Ils ne constituent pas une liste de partenaires, ni un engagement de transmission de votre demande aux organismes cités. Le comparatif est présenté par ordre alphabétique.",
      ],
    },
    {
      h: "Rémunération",
      paras: [
        "Dans le cadre de la mise en relation, la société éditrice perçoit une rémunération de la part de ses partenaires (commission), sans surcoût pour l'utilisateur : la demande de devis est gratuite et sans engagement.",
        "Conformément à l'article R.511-3 du Code des assurances, le montant de la rémunération est communiqué sur demande pour tout projet de contrat dont la prime annuelle dépasse 20 000 €.",
      ],
    },
    RECLAMATIONS,
    { h: "Médiation", paras: [mediationLine()] },
    {
      h: "Liens capitalistiques",
      paras: [
        "La déclaration relative aux éventuels liens capitalistiques entre la société éditrice et des entreprises d'assurance est en cours de publication sur cette page.",
      ],
    },
  ],
};
